<template>
  <header class="l-header" :id="$route.name + 'Header'">
    <div class="l-inner">
      <template v-if="$route.name === 'home'">
        <h1 class="siteTitle">
          <router-link :to="{ name: 'home' }">
            <img src="@/assets/img/logo-bl.svg" :alt="$constants.siteName" />
          </router-link>
        </h1>
      </template>
      <template v-else>
        <p class="siteTitle">
          <router-link :to="{ name: 'home' }">
            <img src="@/assets/img/logo-bl.svg" :alt="$constants.siteName" />
          </router-link>
        </p>
      </template>
    </div>
  </header>
</template>

<script>
export default {
  data() {
    return {
      isVisible: false,
      scrollY: 0
    };
  },
  computed: {
    isMaintenance() {
      return this.$store.getters['view/isMaintenance'];
    }
  }
};
</script>
